module.exports = __webpack_public_path__ + "static/media/Header2.f97c8a55.jpg";